export default function keyize(label) {
    return label.toLowerCase().replace(/\W/g, '')
}
